/**
 * @version 1.0.1
 * @author zhongjie  <zhongjie@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import kyxx from './more/kyxx/index.vue';
import pmxx from './more/pmxx/index.vue';
export default {
    name: 'kypm',
    components:{kyxx, pmxx},
    data() {
        return {
            // 拍卖类型tab
            kylxList: [
                {
                    name: '船舶扣押',
                    code: 'cbky'
                },
                {
                    name: '船舶拍卖',
                    code: 'cbpm'
                },
                {
                    name: '其它拍卖',
                    code: 'qtpm'
                }
            ],
            active:''
        };
    },
    created() {
        this.active = (this.$route.query && this.$route.query.code) || 'cbky';
    },
    methods: {
        // 切换拍卖类型
        changeKylx(code) {
            this.active = code;
        }
    }
};

